import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { compose } from 'redux';
import classNames from 'classnames';
import some from 'lodash/some'

import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';
import { confirmDialog } from 'primereact/confirmdialog';
import { InputText } from 'primereact/inputtext';
import { InputTextarea } from 'primereact/inputtextarea';


import Header from '@components/Header';
import FileInput from '@components/FileInput';

import { preloadInternalUsers } from '@actions/users';
import { getBusiness } from '@actions/business';
import { sendActionToBitacora  } from '@actions/bitacora';
import { getAllowedCountries } from '@utils/countryPermissions';

class importInternals extends Component {
  constructor(props) {
    super(props);
    this.state = {
      btnSubmitLoading: false,
      catalogBusiness: [],
      country: '',
      company: '',
      file: [],
      errors: [],
    };
  }


  seCompaniesByCountry = async () => {
    const { getBusiness, countriesCurrentCatalog } = this.props
    const { country } = this.state
    const requestId = this.companiesRequestId = (this.companiesRequestId || 0) + 1;
    this.setState({catalogBusiness: []})
    if (!countriesCurrentCatalog.some(item => item.id === country?.id)) return;
    const params = {
      type: 'visible',
      country: country?.id || ''
    };
    const response = await getBusiness(params);
    if (requestId !== this.companiesRequestId || this.state.country?.id !== country.id) return;
    if (!response?.status) {
      const catalogBusiness = response.data.map(item => ({ label: item.nombre, id: item.id }))
      return this.setState({catalogBusiness})
    }

  }

  onChange = ({ target }) => {
    if (target.name === 'country') {
      const country = this.props.countriesCurrentCatalog.find(item => item.id === target.value?.id) || '';
      this.companiesRequestId = (this.companiesRequestId || 0) + 1;
      this.setState({ country, company: '', catalogBusiness: [] }, () => {
        if (country) this.seCompaniesByCountry();
        this.validateFieldsOnchange('country', country);
      });
      return;
    }
    this.setState({ [target.name]: target.value }, () => {
      this.validateFieldsOnchange(target.name, target.value)
    });
  };

  validateFieldsOnchange = (name, value) => {
    const { errors } = this.state;
    if (errors[name] && value) {
      delete errors[name];
      this.setState({ errors });
    }
  };

  validateFields = async () => {
    const { t, countriesCurrentCatalog } = this.props;
    const {country, file, company, justification } = this.state;
    let errors = {};
    const isAllowedCountry = countriesCurrentCatalog.some(item => item.id === country?.id);
    const isAvailableCompany = this.state.catalogBusiness.some(item => item.id === company?.id);
    if (!isAllowedCountry) errors = { ...errors, 'country': `${t('País')} ${t('es requerido')}`  }
    if (!isAvailableCompany) errors = { ...errors, 'company': `${t('Empresa')} ${t('es requerido')}`  }
    if (!file.length) errors = { ...errors, 'file': `${t('Archivo')} ${t('es requerido')}`  }
    if (!justification) errors = { ...errors, 'justification': `${t('Justificación del cambio')} ${t('es requerido')}`  }
    this.setState({ errors });
    return errors;
  };

  uploadFile = (files, isImage) => {
    const [file] = files;
    const { name: fileName } = file;
    const localUrl = URL.createObjectURL(file);
    const fileExtension = fileName.split('.').pop();
    const data = {
      fileName,
      currentValue: localUrl,
      file,
      fileExtension,
      isImage,
    };
    this.setState({ file: [data] }, () => this.validateFieldsOnchange('file', data));
  };

  removeFile = () => {
    this.setState({ file: [] });
  }

  onSubmit = async (e) => {
    e.preventDefault();
    this.setState({btnSubmitLoading: true})
    const { history, t, preloadInternalUsers, sendActionToBitacora } = this.props
    const { country, company, file, justification } = this.state
    const validate = await this.validateFields()
    if (some(validate, {})) return this.setState({btnSubmitLoading: false})

    const response = await preloadInternalUsers({
      countryId: country.id,
      companyId: company.id,
      file
    })
    if (!response.status) {
      const dataBitacora = {
        transactionName: 'configCargaInt',
        reason: `${country.label} - ${company.label} || ${justification}`,
      }
      await sendActionToBitacora(dataBitacora)
      return confirmDialog({
        message: t('La operación se ha realizado de manera éxitosa'),
        header: t('Confirmación'),
        icon: 'pi pi-check-circle',
        acceptLabel: t('Continuar'),
        rejectClassName: 'hide-component',
        accept: () => history.push('/users/internal/bulk-load'),
        onHide: () => history.push('/users/internal/bulk-load')
      });
    }
    return this.setState({ btnSubmitLoading: false });
  };

  render() {
    const { t, countriesCurrentCatalog, history } = this.props
    const { country, company, file, btnSubmitLoading, errors, catalogBusiness } = this.state;

    const isFormFieldValid = (name) => !!errors[name];
    const getFormErrorMessage = (name) =>
      isFormFieldValid(name) && (
        <small className="p-error">{errors[name]}</small>
      );


    return (
      <div className="p-grid">
        <div className="p-col-12">
          <Header
            title={t("Importar usuarios")}
            to="/users/internal/bulk-load"
            linkText={t("Ir al listado")}
          />
          <div className="card">
            <form onSubmit={this.onSubmit} autoComplete="false">
              <div className="p-fluid p-grid p-mb-4">
                <div className="p-col-12 p-lg-6 p-field">
                  <label htmlFor="title" className="p-text-bold p-pb-2">
                    {t('País')}
                  </label>
                  <Dropdown
                    name="country"
                    value={country}
                    options={countriesCurrentCatalog}
                    onChange={this.onChange}
                    optionLabel="label"
                    filter
                    showClear
                    autoFocus
                    filterBy="label"
                    style={{ width: '100%' }}
                    className={classNames({
                      'p-invalid': isFormFieldValid(`country`),
                    })}
                  />
                  {getFormErrorMessage(`country`)}
                </div>
                <div className="p-col-12 p-lg-6 p-field">
                  <label htmlFor="title" className="p-text-bold p-pb-2">
                    {t('Empresa')}
                  </label>
                  <Dropdown
                    name="company"
                    value={company}
                    options={catalogBusiness}
                    onChange={this.onChange}
                    disabled={!country}
                    optionLabel="label"
                    filter
                    showClear
                    autoFocus
                    filterBy="label"
                    style={{ width: '100%' }}
                    className={classNames({
                      'p-invalid': isFormFieldValid(`company`),
                    })}
                  />
                  {getFormErrorMessage(`company`)}
                </div>
                <div className="p-col-12">
                <label className="p-text-bold">{t('Justificación del cambio')}</label>
                <InputTextarea
                  name="justification"
                  onChange={(e) =>
                    this.setState({ justification: e.target.value }, this.validateFieldsOnchange('justification', e.target.value))
                  }
                  rows={5}
                  cols={30}
                  className={classNames({
                    'p-invalid': isFormFieldValid(`justification`),
                  })}
                />
                {getFormErrorMessage(`justification`)}
              </div>
                <div className="p-col-12 p-md-6 p-lg-6">
                  <label htmlFor="title" className="p-text-bold p-pb-2">
                    {t('Archivo')}
                  </label>
                  <FileInput
                    onChangeFile={this.uploadFile}
                    files={file}
                    removeAllFiles={this.removeFile}
                    removeFile={this.removeFile}
                    maxFileSize={10500000}
                    accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                    txtDrop={t('Arrastra y suelta el archivo')}
                    classNameBorderMain={classNames({
                      'p-invalid': isFormFieldValid('file'),
                    })}
                  />
                  {getFormErrorMessage(`file`)}
                </div>
              </div>
              <div className="p-col-12 footer-btn">
                <div className="p-d-flex p-jc-between">
                  <Button
                    label={t('Cancelar')}
                    type="button"
                    className="p-button-secondary"
                    onClick={() => history.push('/users/internal/bulk-load')}
                  />
                  <Button
                    label={t('Cargar archivo')}
                    type="submit"
                    className="p-button-primary"
                    loading={btnSubmitLoading}
                  />
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  countriesCurrentCatalog: getAllowedCountries(state.catalogs.countriesCurrentCatalog, state.sessionPermission),
});

const mapDispatchToProps = {
  preloadInternalUsers,
  getBusiness,
  sendActionToBitacora 
};

export default compose(
  withTranslation(),
  connect(mapStateToProps, mapDispatchToProps)
  )(importInternals);
